
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MailingListApiModel, CreateMailingListApiModel, UpdateMailingListApiModel } from './models/mailingList.api.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { CreateRecipientApiModel, UpdateRecipientApiModel, RecipientApiModel } from './models/recipient.api.model';
import { RecipientSearchResultsApiModel } from './models/recipient-search-results.api.model';
import { RecipientSearchRequestModel } from './models/recipient-search-request.model';

@Injectable()
export class MailingListsApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    getAllMailingLists(): Observable<MailingListApiModel[]> {
        return this.neptuneApi.api<MailingListApiModel[]>(
            '/mailingLists/all',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    createMailingList(createMailingListModel: CreateMailingListApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/mailingLists',
            createMailingListModel,
            HttpVerbsEnum.POST
        );
    }

    updateMailingList(updateMailingListModel: UpdateMailingListApiModel, removal: boolean): Observable<void> {

        let slug = `/mailingLists/${updateMailingListModel.id}`;
        if (removal) {
            slug += '?isRemove=true';
        }

        return this.neptuneApi.api<void>(
            slug,
            updateMailingListModel,
            HttpVerbsEnum.PUT
        );
    }
    deleteMailingList(id: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/mailingLists/${id}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }
    exportMailingList(id: number): Observable<string> {
        return this.neptuneApi.api<string>(
            `/mailingLists/${id}/export`,
            id,
            HttpVerbsEnum.GET,
            null,
            'text'
        );
    }

    getRecipientById(id: number): Observable<RecipientApiModel> {
        return this.getRecipientsByIds([id]).pipe(map(results => results[0]));
    }
    getRecipientsByIds(ids: number[]): Observable<RecipientApiModel[]> {
        return this.neptuneApi.api<RecipientApiModel[]>(
            '/mailingLists/recipients/batch',
            ids,
            HttpVerbsEnum.POST
        );
    }
    searchRecipients(query: string, pageNumber: number = 0, pageSize: number = 25): Observable<RecipientSearchResultsApiModel> {
        const body: RecipientSearchRequestModel = {
            page: pageNumber + 1,
            pageSize: pageSize
        };
        if (query) {
            body.keyword = query;
        }
        return this.neptuneApi.api<RecipientSearchResultsApiModel>(
            '/mailingLists/recipients/search',
            body,
            HttpVerbsEnum.POST
        );
    }
    createRecipient(createRecipient: CreateRecipientApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/mailingLists/recipients',
            createRecipient,
            HttpVerbsEnum.POST
        );
    }
    updateRecipient(updateRecipient: UpdateRecipientApiModel): Observable<void> {
        return this.neptuneApi.api<void>(
            `/mailingLists/recipients/${updateRecipient.id}`,
            updateRecipient,
            HttpVerbsEnum.PUT
        );
    }
    deleteRecipient(id: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/mailingLists/recipients/${id}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    deleteRecipientsBulk(ids: number[]): Observable<void> {
        return this.neptuneApi.api<void>(
            `/mailingLists/recipients/bulk?ids=${ids.join(',')}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    deleteAllRecipients(): Observable<void> {
        return this.neptuneApi.api<void>(
            '/mailingLists/recipients/all',
            null,
            HttpVerbsEnum.DELETE
        );
    }

    deleteRecipientsByMailingList(mailingListId: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/mailingLists/${mailingListId}/recipients`,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    importRecipients(recipients: CreateRecipientApiModel[], list?: UpdateMailingListApiModel): Observable<void> {
        const body: {recipients: CreateRecipientApiModel[]; mailingListId?: number} = {
            recipients: recipients
        };
        if (list) {
            body.mailingListId = list.id;
        }
        return this.neptuneApi.api<void>(
            '/mailingLists/importRecipients',
            body,
            HttpVerbsEnum.POST
        );
    }
}
